import { useState } from 'react';
import { InputErrorMessage, ButtonLoader } from '../ui';

export const ForgotPasswordForm = ({ onSubmit, isLoading = false }) => {
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({ email: '' });
  const [touched, setTouched] = useState({ email: false });

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validate = (value = email) => {
    if (!value.trim()) {
      return "L'adresse email est obligatoire.";
    }
    if (!emailRegex.test(value.trim())) {
      return "Format d'email invalide.";
    }
    return '';
  };

  const handleChange = (value) => {
    setEmail(value);
    setErrors({ email: validate(value) });
  };

  const handleBlur = () => {
    setTouched({ email: true });
    setErrors({ email: validate(email) });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const nextError = validate(email);

    if (nextError) {
      setErrors({ email: nextError });
      setTouched({ email: true });
      return;
    }

    onSubmit(email);
  };

  const baseInputClasses =
    'w-[320px] h-[52px] rounded-[18px] border border-transparent px-5 py-3 text-base text-gray-800 placeholder:text-gray-400 shadow-[0_10px_24px_rgba(0,0,0,0.08)] transition focus:outline-none focus:ring-2';
  const normalInputClasses = 'bg-white border-[#c9ece6] focus:border-[#009688] focus:ring-[#00a389]/45';
  const errorInputClasses =
    'bg-red-50 border-red-400 focus:border-red-400 focus:ring-red-400 placeholder:text-red-500/80';

  return (
    <form className="flex w-full flex-col items-center gap-6" onSubmit={handleSubmit}>
      <div className="flex flex-col items-center gap-2">
        <label htmlFor="email" className="sr-only">
          Adresse email
        </label>
        <input
          id="email"
          type="email"
          placeholder="Adresse email"
          value={email}
          onChange={(e) => handleChange(e.target.value)}
          onBlur={handleBlur}
          aria-invalid={touched.email && !!errors.email}
          aria-describedby={touched.email && errors.email ? 'forgot-email-error' : undefined}
          className={`${baseInputClasses} ${touched.email && errors.email ? errorInputClasses : normalInputClasses}`}
          required
          disabled={isLoading}
        />
        <InputErrorMessage
          id="forgot-email-error"
          message={touched.email ? errors.email : ''}
          className="w-[320px]"
        />
      </div>

      <button
        type="submit"
        disabled={isLoading}
        className="w-[320px] rounded-[24px] bg-[#009688] py-3 text-base font-semibold text-white shadow-[0_10px_20px_rgba(0,163,137,0.2)] transition hover:bg-[#00967d] disabled:cursor-not-allowed disabled:bg-[#9bd9ce]"
      >
        {isLoading ? <ButtonLoader label="Envoi en cours..." /> : 'Réinitialiser mon mot de passe'}
      </button>
    </form>
  );
};
